module.exports = __webpack_public_path__ + "img/client-logo.30241364.svg";